module.exports = __webpack_public_path__ + "static/media/Helicopter_Control_Room_01.17c193a2.jpg";